"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// index.ts
var index_exports = {};
__export(index_exports, {
  CauseOfFailure: () => CauseOfFailure,
  CollectionsFound: () => CollectionsFound,
  ConnectionType: () => ConnectionType,
  FieldType: () => FieldType,
  ProtocolVersion: () => ProtocolVersion,
  WebhookIdentityType: () => WebhookIdentityType,
  createExternalDatabaseConnection: () => createExternalDatabaseConnection4,
  deleteExternalDatabaseConnection: () => deleteExternalDatabaseConnection4,
  getExternalDatabaseConnection: () => getExternalDatabaseConnection4,
  listExternalDatabaseConnections: () => listExternalDatabaseConnections4,
  updateExternalDatabaseConnection: () => updateExternalDatabaseConnection4
});
module.exports = __toCommonJS(index_exports);

// src/data-v1-external-database-connection-external-database-connections.universal.ts
var import_transform_error = require("@wix/sdk-runtime/transform-error");
var import_rename_all_nested_keys = require("@wix/sdk-runtime/rename-all-nested-keys");

// src/data-v1-external-database-connection-external-database-connections.http.ts
var import_rest_modules = require("@wix/sdk-runtime/rest-modules");
var import_rest_modules2 = require("@wix/sdk-runtime/rest-modules");
function resolveComWixpressCloudDataApiExternaldatabaseExternalDatabaseConnectionServiceUrl(opts) {
  const domainToMappings = {
    "api._api_base_domain_": [
      {
        srcPath: "/cloud-data",
        destPath: ""
      }
    ],
    "code._base_domain_": [
      {
        srcPath: "/_api/cloud-data/v1/data-settings",
        destPath: "/v1/data-settings"
      },
      {
        srcPath: "/_api/cloud-data/v1/schemas",
        destPath: "/v1/schemas"
      },
      {
        srcPath: "/_api/cloud-data/v1/connector",
        destPath: "/v1/connector"
      },
      {
        srcPath: "/_api/data/v1/data-settings",
        destPath: "/v1/data-settings"
      },
      {
        srcPath: "/_api/data/v1/schemas",
        destPath: "/v1/schemas"
      },
      {
        srcPath: "/_api/data/v1/connector",
        destPath: "/v1/connector"
      },
      {
        srcPath: "/_api/cloud-data/v1/wix-data",
        destPath: "/v1/wix-data"
      }
    ],
    "cloud-data.wix-code.com": [
      {
        srcPath: "",
        destPath: ""
      }
    ],
    _: [
      {
        srcPath: "/_api/cloud-data",
        destPath: ""
      }
    ],
    "www._base_domain_": [
      {
        srcPath: "/_api/cloud-data",
        destPath: ""
      },
      {
        srcPath: "/_api/data",
        destPath: ""
      },
      {
        srcPath: "/_api/cloud-data",
        destPath: ""
      }
    ],
    "dev._base_domain_": [
      {
        srcPath: "/_api/cloud-data",
        destPath: ""
      }
    ],
    "bo._base_domain_": [
      {
        srcPath: "/_api/cloud-data/v1",
        destPath: "/v1"
      },
      {
        srcPath: "/_api/cloud-data/v2",
        destPath: "/v2"
      }
    ],
    "wixbo.ai": [
      {
        srcPath: "/_api/cloud-data/v1",
        destPath: "/v1"
      },
      {
        srcPath: "/_api/cloud-data/v2",
        destPath: "/v2"
      }
    ],
    "wix-bo.com": [
      {
        srcPath: "/_api/cloud-data/v1",
        destPath: "/v1"
      },
      {
        srcPath: "/_api/cloud-data/v2",
        destPath: "/v2"
      }
    ],
    "manage._base_domain_": [
      {
        srcPath: "/_api/cloud-data",
        destPath: ""
      },
      {
        srcPath: "/_api/data",
        destPath: ""
      },
      {
        srcPath: "/_api/cloud-data",
        destPath: ""
      }
    ],
    "editor._base_domain_": [
      {
        srcPath: "/_api/cloud-data/v1/schemas",
        destPath: "/v1/schemas"
      },
      {
        srcPath: "/_api/cloud-data/dbs/tasks",
        destPath: "/dbs/tasks"
      },
      {
        srcPath: "/_api/data/v1/schemas",
        destPath: "/v1/schemas"
      },
      {
        srcPath: "/_api/data/dbs/tasks",
        destPath: "/dbs/tasks"
      },
      {
        srcPath: "/_api/cloud-data/v1/wix-data",
        destPath: "/v1/wix-data"
      },
      {
        srcPath: "/_api/cloud-data/v1/data-settings",
        destPath: "/v1/data-settings"
      },
      {
        srcPath: "/_api/data/v2/indexes",
        destPath: "/v2/indexes"
      },
      {
        srcPath: "/_api/cloud-data/v1/external-database-connections",
        destPath: "/v1/external-database-connections"
      },
      {
        srcPath: "/_api/data/v1/data-collection-sharing",
        destPath: "/v1/data-collection-sharing"
      },
      {
        srcPath: "/_api/cloud-data/v2/collections",
        destPath: "/v2/collections"
      },
      {
        srcPath: "/_api/cloud-data/v2/bulk",
        destPath: "/v2/bulk"
      },
      {
        srcPath: "/_api/cloud-data/v2/items",
        destPath: "/v2/items"
      },
      {
        srcPath: "/_api/cloud-data/v2/dbs/tasks",
        destPath: "/v2/dbs/tasks"
      }
    ],
    "blocks._base_domain_": [
      {
        srcPath: "/_api/cloud-data/v1/schemas",
        destPath: "/v1/schemas"
      },
      {
        srcPath: "/_api/cloud-data/dbs/tasks",
        destPath: "/dbs/tasks"
      },
      {
        srcPath: "/_api/data/v1/schemas",
        destPath: "/v1/schemas"
      },
      {
        srcPath: "/_api/data/dbs/tasks",
        destPath: "/dbs/tasks"
      },
      {
        srcPath: "/_api/cloud-data/v1/wix-data",
        destPath: "/v1/wix-data"
      },
      {
        srcPath: "/_api/cloud-data/v1/data-settings",
        destPath: "/v1/data-settings"
      },
      {
        srcPath: "/_api/data/v2/indexes",
        destPath: "/v2/indexes"
      },
      {
        srcPath: "/_api/cloud-data/v1/external-database-connections",
        destPath: "/v1/external-database-connections"
      },
      {
        srcPath: "/_api/data/v1/data-collection-sharing",
        destPath: "/v1/data-collection-sharing"
      },
      {
        srcPath: "/_api/cloud-data/v2/collections",
        destPath: "/v2/collections"
      },
      {
        srcPath: "/_api/cloud-data/v2/bulk",
        destPath: "/v2/bulk"
      },
      {
        srcPath: "/_api/cloud-data/v2/items",
        destPath: "/v2/items"
      },
      {
        srcPath: "/_api/cloud-data/v2/dbs/tasks",
        destPath: "/v2/dbs/tasks"
      }
    ],
    "create.editorx": [
      {
        srcPath: "/_api/cloud-data/v1/schemas",
        destPath: "/v1/schemas"
      },
      {
        srcPath: "/_api/cloud-data/dbs/tasks",
        destPath: "/dbs/tasks"
      },
      {
        srcPath: "/_api/data/v1/schemas",
        destPath: "/v1/schemas"
      },
      {
        srcPath: "/_api/data/dbs/tasks",
        destPath: "/dbs/tasks"
      },
      {
        srcPath: "/_api/cloud-data/v1/wix-data",
        destPath: "/v1/wix-data"
      },
      {
        srcPath: "/_api/cloud-data/v1/data-settings",
        destPath: "/v1/data-settings"
      },
      {
        srcPath: "/_api/data/v2/indexes",
        destPath: "/v2/indexes"
      },
      {
        srcPath: "/_api/cloud-data/v1/external-database-connections",
        destPath: "/v1/external-database-connections"
      },
      {
        srcPath: "/_api/data/v1/data-collection-sharing",
        destPath: "/v1/data-collection-sharing"
      },
      {
        srcPath: "/_api/cloud-data/v2/collections",
        destPath: "/v2/collections"
      },
      {
        srcPath: "/_api/cloud-data/v2/bulk",
        destPath: "/v2/bulk"
      },
      {
        srcPath: "/_api/cloud-data/v2/items",
        destPath: "/v2/items"
      },
      {
        srcPath: "/_api/cloud-data/v2/dbs/tasks",
        destPath: "/v2/dbs/tasks"
      }
    ],
    "www.wixapis.com": [
      {
        srcPath: "/wix-data/v1/collections",
        destPath: "/v1/wix-data/collections"
      },
      {
        srcPath: "/wix-data/v1/external-database-connections",
        destPath: "/v1/external-database-connections"
      },
      {
        srcPath: "/wix-data/v2/indexes",
        destPath: "/v2/indexes"
      },
      {
        srcPath: "/wix-data/v1/items",
        destPath: "/v1/items"
      },
      {
        srcPath: "/wix-data/v1/bulk",
        destPath: "/v1/bulk"
      },
      {
        srcPath: "/wix-data/v1/external-databases",
        destPath: "/v1/external-databases"
      },
      {
        srcPath: "/wix-data/v2",
        destPath: "/v2"
      }
    ],
    "www.wixgateway.com": [
      {
        srcPath: "/wix-data/v1/items",
        destPath: "/v1/items"
      },
      {
        srcPath: "/wix-data/v1/bulk",
        destPath: "/v1/bulk"
      }
    ],
    "*.dev.wix-code.com": [
      {
        srcPath: "/_api/cloud-data/v2",
        destPath: "/v2"
      },
      {
        srcPath: "/_api/cloud-data/v1/external-database-connections",
        destPath: "/v1/external-database-connections"
      }
    ]
  };
  return (0, import_rest_modules2.resolveUrl)(Object.assign(opts, { domainToMappings }));
}
var PACKAGE_NAME = "@wix/auto_sdk_data_external-database-connections";
function getExternalDatabaseConnection(payload) {
  function __getExternalDatabaseConnection({ host }) {
    const metadata = {
      entityFqdn: "wix.data.v1.external_database_connection",
      method: "GET",
      methodFqn: "com.wixpress.cloud.data.api.externaldatabase.ExternalDatabaseConnectionService.GetExternalDatabaseConnection",
      packageName: PACKAGE_NAME,
      url: resolveComWixpressCloudDataApiExternaldatabaseExternalDatabaseConnectionServiceUrl(
        {
          protoPath: "/v1/external-database-connections/{name}",
          data: payload,
          host
        }
      ),
      params: (0, import_rest_modules.toURLSearchParams)(payload)
    };
    return metadata;
  }
  return __getExternalDatabaseConnection;
}
function listExternalDatabaseConnections(payload) {
  function __listExternalDatabaseConnections({ host }) {
    const metadata = {
      entityFqdn: "wix.data.v1.external_database_connection",
      method: "GET",
      methodFqn: "com.wixpress.cloud.data.api.externaldatabase.ExternalDatabaseConnectionService.ListExternalDatabaseConnections",
      packageName: PACKAGE_NAME,
      url: resolveComWixpressCloudDataApiExternaldatabaseExternalDatabaseConnectionServiceUrl(
        { protoPath: "/v1/external-database-connections", data: payload, host }
      ),
      params: (0, import_rest_modules.toURLSearchParams)(payload)
    };
    return metadata;
  }
  return __listExternalDatabaseConnections;
}
function createExternalDatabaseConnection(payload) {
  function __createExternalDatabaseConnection({ host }) {
    const metadata = {
      entityFqdn: "wix.data.v1.external_database_connection",
      method: "POST",
      methodFqn: "com.wixpress.cloud.data.api.externaldatabase.ExternalDatabaseConnectionService.CreateExternalDatabaseConnection",
      packageName: PACKAGE_NAME,
      url: resolveComWixpressCloudDataApiExternaldatabaseExternalDatabaseConnectionServiceUrl(
        { protoPath: "/v1/external-database-connections", data: payload, host }
      ),
      data: payload
    };
    return metadata;
  }
  return __createExternalDatabaseConnection;
}
function updateExternalDatabaseConnection(payload) {
  function __updateExternalDatabaseConnection({ host }) {
    const metadata = {
      entityFqdn: "wix.data.v1.external_database_connection",
      method: "PUT",
      methodFqn: "com.wixpress.cloud.data.api.externaldatabase.ExternalDatabaseConnectionService.UpdateExternalDatabaseConnection",
      packageName: PACKAGE_NAME,
      url: resolveComWixpressCloudDataApiExternaldatabaseExternalDatabaseConnectionServiceUrl(
        {
          protoPath: "/v1/external-database-connections/{externalDatabaseConnection.name}",
          data: payload,
          host
        }
      ),
      data: payload
    };
    return metadata;
  }
  return __updateExternalDatabaseConnection;
}
function deleteExternalDatabaseConnection(payload) {
  function __deleteExternalDatabaseConnection({ host }) {
    const metadata = {
      entityFqdn: "wix.data.v1.external_database_connection",
      method: "DELETE",
      methodFqn: "com.wixpress.cloud.data.api.externaldatabase.ExternalDatabaseConnectionService.DeleteExternalDatabaseConnection",
      packageName: PACKAGE_NAME,
      url: resolveComWixpressCloudDataApiExternaldatabaseExternalDatabaseConnectionServiceUrl(
        {
          protoPath: "/v1/external-database-connections/{name}",
          data: payload,
          host
        }
      ),
      params: (0, import_rest_modules.toURLSearchParams)(payload)
    };
    return metadata;
  }
  return __deleteExternalDatabaseConnection;
}

// src/data-v1-external-database-connection-external-database-connections.universal.ts
var CauseOfFailure = /* @__PURE__ */ ((CauseOfFailure2) => {
  CauseOfFailure2["NONE"] = "NONE";
  CauseOfFailure2["COMMUNICATION_FAILURE"] = "COMMUNICATION_FAILURE";
  CauseOfFailure2["DESTINATION_HOST_UNREACHABLE"] = "DESTINATION_HOST_UNREACHABLE";
  CauseOfFailure2["UNAUTHORIZED"] = "UNAUTHORIZED";
  CauseOfFailure2["DESTINATION_ENDPOINT_NOT_DEFINED"] = "DESTINATION_ENDPOINT_NOT_DEFINED";
  return CauseOfFailure2;
})(CauseOfFailure || {});
var CollectionsFound = /* @__PURE__ */ ((CollectionsFound2) => {
  CollectionsFound2["UNKNOWN"] = "UNKNOWN";
  CollectionsFound2["YES"] = "YES";
  CollectionsFound2["NO"] = "NO";
  return CollectionsFound2;
})(CollectionsFound || {});
var FieldType = /* @__PURE__ */ ((FieldType2) => {
  FieldType2["UNKNOWN_FIELD_TYPE"] = "UNKNOWN_FIELD_TYPE";
  FieldType2["TEXT"] = "TEXT";
  FieldType2["NUMBER"] = "NUMBER";
  FieldType2["DATE"] = "DATE";
  FieldType2["DATETIME"] = "DATETIME";
  FieldType2["IMAGE"] = "IMAGE";
  FieldType2["BOOLEAN"] = "BOOLEAN";
  FieldType2["DOCUMENT"] = "DOCUMENT";
  FieldType2["URL"] = "URL";
  FieldType2["RICH_TEXT"] = "RICH_TEXT";
  FieldType2["VIDEO"] = "VIDEO";
  FieldType2["ANY"] = "ANY";
  FieldType2["ARRAY_STRING"] = "ARRAY_STRING";
  FieldType2["ARRAY_DOCUMENT"] = "ARRAY_DOCUMENT";
  FieldType2["AUDIO"] = "AUDIO";
  FieldType2["TIME"] = "TIME";
  FieldType2["LANGUAGE"] = "LANGUAGE";
  FieldType2["RICH_CONTENT"] = "RICH_CONTENT";
  FieldType2["MEDIA_GALLERY"] = "MEDIA_GALLERY";
  FieldType2["ADDRESS"] = "ADDRESS";
  FieldType2["PAGE_LINK"] = "PAGE_LINK";
  FieldType2["REFERENCE"] = "REFERENCE";
  FieldType2["MULTI_REFERENCE"] = "MULTI_REFERENCE";
  FieldType2["OBJECT"] = "OBJECT";
  FieldType2["ARRAY"] = "ARRAY";
  FieldType2["LEGACY_TIME"] = "LEGACY_TIME";
  FieldType2["LEGACY_BOOK"] = "LEGACY_BOOK";
  FieldType2["LEGACY_EXTERNAL_URL"] = "LEGACY_EXTERNAL_URL";
  FieldType2["LEGACY_BROKEN_REFERENCE"] = "LEGACY_BROKEN_REFERENCE";
  FieldType2["LEGACY_IMAGE"] = "LEGACY_IMAGE";
  FieldType2["LEGACY_COLOR"] = "LEGACY_COLOR";
  FieldType2["LEGACY_EXTERNAL_VIDEO"] = "LEGACY_EXTERNAL_VIDEO";
  return FieldType2;
})(FieldType || {});
var ProtocolVersion = /* @__PURE__ */ ((ProtocolVersion2) => {
  ProtocolVersion2["UNKNOWN_PROTOCOL_VERSION"] = "UNKNOWN_PROTOCOL_VERSION";
  ProtocolVersion2["V1"] = "V1";
  ProtocolVersion2["V2"] = "V2";
  ProtocolVersion2["V3"] = "V3";
  return ProtocolVersion2;
})(ProtocolVersion || {});
var ConnectionType = /* @__PURE__ */ ((ConnectionType2) => {
  ConnectionType2["UNKNOWN_CONNECTION_TYPE"] = "UNKNOWN_CONNECTION_TYPE";
  ConnectionType2["STANDALONE"] = "STANDALONE";
  ConnectionType2["WIX_SERVICE_PLUGIN"] = "WIX_SERVICE_PLUGIN";
  return ConnectionType2;
})(ConnectionType || {});
var WebhookIdentityType = /* @__PURE__ */ ((WebhookIdentityType2) => {
  WebhookIdentityType2["UNKNOWN"] = "UNKNOWN";
  WebhookIdentityType2["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
  WebhookIdentityType2["MEMBER"] = "MEMBER";
  WebhookIdentityType2["WIX_USER"] = "WIX_USER";
  WebhookIdentityType2["APP"] = "APP";
  return WebhookIdentityType2;
})(WebhookIdentityType || {});
async function getExternalDatabaseConnection2(name) {
  const { httpClient, sideEffects } = arguments[1];
  const payload = (0, import_rename_all_nested_keys.renameKeysFromSDKRequestToRESTRequest)({ name });
  const reqOpts = getExternalDatabaseConnection(
    payload
  );
  sideEffects?.onSiteCall?.();
  try {
    const result = await httpClient.request(reqOpts);
    sideEffects?.onSuccess?.(result);
    return (0, import_rename_all_nested_keys.renameKeysFromRESTResponseToSDKResponse)(result.data)?.externalDatabaseConnection;
  } catch (err) {
    const transformedError = (0, import_transform_error.transformError)(
      err,
      {
        spreadPathsToArguments: {},
        explicitPathsToArguments: { name: "$[0]" },
        singleArgumentUnchanged: false
      },
      ["name"]
    );
    sideEffects?.onError?.(err);
    throw transformedError;
  }
}
async function listExternalDatabaseConnections2(options) {
  const { httpClient, sideEffects } = arguments[1];
  const payload = (0, import_rename_all_nested_keys.renameKeysFromSDKRequestToRESTRequest)({
    paging: options?.paging
  });
  const reqOpts = listExternalDatabaseConnections(
    payload
  );
  sideEffects?.onSiteCall?.();
  try {
    const result = await httpClient.request(reqOpts);
    sideEffects?.onSuccess?.(result);
    return (0, import_rename_all_nested_keys.renameKeysFromRESTResponseToSDKResponse)(result.data);
  } catch (err) {
    const transformedError = (0, import_transform_error.transformError)(
      err,
      {
        spreadPathsToArguments: {},
        explicitPathsToArguments: { paging: "$[0].paging" },
        singleArgumentUnchanged: false
      },
      ["options"]
    );
    sideEffects?.onError?.(err);
    throw transformedError;
  }
}
async function createExternalDatabaseConnection2(externalDatabaseConnection, connectionType) {
  const { httpClient, sideEffects } = arguments[2];
  const payload = (0, import_rename_all_nested_keys.renameKeysFromSDKRequestToRESTRequest)({
    externalDatabaseConnection,
    connectionType
  });
  const reqOpts = createExternalDatabaseConnection(
    payload
  );
  sideEffects?.onSiteCall?.();
  try {
    const result = await httpClient.request(reqOpts);
    sideEffects?.onSuccess?.(result);
    return (0, import_rename_all_nested_keys.renameKeysFromRESTResponseToSDKResponse)(result.data)?.externalDatabaseConnection;
  } catch (err) {
    const transformedError = (0, import_transform_error.transformError)(
      err,
      {
        spreadPathsToArguments: {},
        explicitPathsToArguments: {
          externalDatabaseConnection: "$[0]",
          connectionType: "$[1]"
        },
        singleArgumentUnchanged: false
      },
      ["externalDatabaseConnection", "connectionType"]
    );
    sideEffects?.onError?.(err);
    throw transformedError;
  }
}
async function updateExternalDatabaseConnection2(name, externalDatabaseConnection) {
  const { httpClient, sideEffects } = arguments[2];
  const payload = (0, import_rename_all_nested_keys.renameKeysFromSDKRequestToRESTRequest)({
    externalDatabaseConnection: { ...externalDatabaseConnection, name }
  });
  const reqOpts = updateExternalDatabaseConnection(
    payload
  );
  sideEffects?.onSiteCall?.();
  try {
    const result = await httpClient.request(reqOpts);
    sideEffects?.onSuccess?.(result);
    return (0, import_rename_all_nested_keys.renameKeysFromRESTResponseToSDKResponse)(result.data)?.externalDatabaseConnection;
  } catch (err) {
    const transformedError = (0, import_transform_error.transformError)(
      err,
      {
        spreadPathsToArguments: { externalDatabaseConnection: "$[1]" },
        explicitPathsToArguments: { "externalDatabaseConnection.name": "$[0]" },
        singleArgumentUnchanged: false
      },
      ["name", "externalDatabaseConnection"]
    );
    sideEffects?.onError?.(err);
    throw transformedError;
  }
}
async function deleteExternalDatabaseConnection2(name) {
  const { httpClient, sideEffects } = arguments[1];
  const payload = (0, import_rename_all_nested_keys.renameKeysFromSDKRequestToRESTRequest)({ name });
  const reqOpts = deleteExternalDatabaseConnection(
    payload
  );
  sideEffects?.onSiteCall?.();
  try {
    const result = await httpClient.request(reqOpts);
    sideEffects?.onSuccess?.(result);
  } catch (err) {
    const transformedError = (0, import_transform_error.transformError)(
      err,
      {
        spreadPathsToArguments: {},
        explicitPathsToArguments: { name: "$[0]" },
        singleArgumentUnchanged: false
      },
      ["name"]
    );
    sideEffects?.onError?.(err);
    throw transformedError;
  }
}

// src/data-v1-external-database-connection-external-database-connections.public.ts
function getExternalDatabaseConnection3(httpClient) {
  return (name) => getExternalDatabaseConnection2(
    name,
    // @ts-ignore
    { httpClient }
  );
}
function listExternalDatabaseConnections3(httpClient) {
  return (options) => listExternalDatabaseConnections2(
    options,
    // @ts-ignore
    { httpClient }
  );
}
function createExternalDatabaseConnection3(httpClient) {
  return (externalDatabaseConnection, connectionType) => createExternalDatabaseConnection2(
    externalDatabaseConnection,
    connectionType,
    // @ts-ignore
    { httpClient }
  );
}
function updateExternalDatabaseConnection3(httpClient) {
  return (name, externalDatabaseConnection) => updateExternalDatabaseConnection2(
    name,
    externalDatabaseConnection,
    // @ts-ignore
    { httpClient }
  );
}
function deleteExternalDatabaseConnection3(httpClient) {
  return (name) => deleteExternalDatabaseConnection2(
    name,
    // @ts-ignore
    { httpClient }
  );
}

// src/data-v1-external-database-connection-external-database-connections.context.ts
var import_rest_modules3 = require("@wix/sdk-runtime/rest-modules");
var getExternalDatabaseConnection4 = /* @__PURE__ */ (0, import_rest_modules3.createRESTModule)(getExternalDatabaseConnection3);
var listExternalDatabaseConnections4 = /* @__PURE__ */ (0, import_rest_modules3.createRESTModule)(listExternalDatabaseConnections3);
var createExternalDatabaseConnection4 = /* @__PURE__ */ (0, import_rest_modules3.createRESTModule)(createExternalDatabaseConnection3);
var updateExternalDatabaseConnection4 = /* @__PURE__ */ (0, import_rest_modules3.createRESTModule)(updateExternalDatabaseConnection3);
var deleteExternalDatabaseConnection4 = /* @__PURE__ */ (0, import_rest_modules3.createRESTModule)(deleteExternalDatabaseConnection3);
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  CauseOfFailure,
  CollectionsFound,
  ConnectionType,
  FieldType,
  ProtocolVersion,
  WebhookIdentityType,
  createExternalDatabaseConnection,
  deleteExternalDatabaseConnection,
  getExternalDatabaseConnection,
  listExternalDatabaseConnections,
  updateExternalDatabaseConnection
});
//# sourceMappingURL=index.js.map